import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UserList from '@app/views/User/List';
import { memo } from 'react';

export default memo(
  withIfUser(UserList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
